import {Component, Inject, OnInit,} from '@angular/core';

import {ActivatedRoute, Router} from '@angular/router';

import {
  AlertService,
  AuthenticationService,
  ClientProfileService,
  ProjectService,
  TenantService,
  UserService,
} from '../../_services/index';

import {User} from '../../_models/index';

import {MatDialog, MatDialogConfig} from "@angular/material/dialog";

import {LoginHelper, Recurring, Role} from '../../helpers';
import {DOCUMENT} from "@angular/common";
import * as moment from 'moment';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {ActionItemService} from "../../_services/actionItem.service";
import {DocumentSelectComponent} from "../documentSelect";
import {IndexConfigService} from "../../_services/index.config.service";
import {Constants} from "../../helpers/constants";
import {ListMessageComponent} from "../listMessage";
import {EditActionItemSetComponent} from "../editActionItemSet/editActionItemSet.component";

const defaultDialogConfig = new MatDialogConfig();

@Component({
    standalone: false,
  selector: "actionItemTemplate-component",
  templateUrl: 'actionItemTemplate.component.html',
  styleUrls: ['./actionItemTemplate.component.scss'],
})

export class ActionItemTemplateComponent implements OnInit {
  api = window.location.origin;
  items: any[];
  actionItemId: number = null;
  actionItemSets = [];
  canEdit: boolean = false;
  tenantName: string;
  recurringList: any[];
  approvalCols: any[] = [
    {field: 'startDate', header: 'Period'},
    {field: 'approver', header: 'Approver'},
    {field: 'isApproved', header: 'Approval Status', width: '40px'},
    {field: 'note', header: 'Note', width: '200px'},
  ];
  users: User[] = [];
  rowGroupMetadata: any;
  isMaster: boolean = false;
  settings: any;
  isEditable = false;
  projectsMap = {};
  constants = Constants;

  constructor(
    public config: IndexConfigService,
    public route: ActivatedRoute,
    public router: Router,
    public alertService: AlertService,
    public authenticationService: AuthenticationService,
    public userService: UserService,
    public dialog: MatDialog,
    @Inject(DOCUMENT) public document: any,
    public _formBuilder: FormBuilder,
    public tenantService: TenantService,
    public projectService: ProjectService,
    public clientProfileService: ClientProfileService,
    public actionItemService: ActionItemService) {
    this.recurringList = [];
    for (let i = Recurring.Monthly; i <= Recurring.Yearly; i++) {
      this.recurringList.push({label: Recurring[i].toString(), value: i});
    }
    this.projectService.getAllShort().subscribe(p => p.forEach(r => this.projectsMap[r.projectId] = r.name))
  }

  initForm(value) {
    const controls = {
      weaknessDescription: [null, [Validators.required]],
      howIdentified: [null, [Validators.required]],
      //responsibleParty: [null],
      //identificationDate: [null],
      currentStatus: [null],
      //scheduledCompletionDate: [null],
      //actualCompletionDate: [null],
      remediationPlansActionsMilestones: [null],
      changesToRemediationPlansActionsMilestones: [null],
      comments: [null],
      projectId: [null],
      poamId: [null],
      name: ['', [Validators.required]],
      category: ['', [Validators.required]],
      actionPlanId: [null],
      type: [true],
      riskLevel: [''],
      actionPlanTemplateId: [null],
      view: [null],
      originalCategory: [],
      assignedTo: [],
      isAllOverride: [false],
      isProtected: [false],
      actionPlanTemplateSetId: [null]
    };

    const actionItemForm = this._formBuilder.group(controls);
    actionItemForm.patchValue(value);
    return actionItemForm;
  }

  ngOnInit() {
    this.tenantName = LoginHelper.getTenantName();
    const currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
    this.canEdit = (currentUser.role & (Role.AdvisorLead | Role.PrimaryAdvisorLead | Role.PlatformSupport)) != 0 ||
      (currentUser.role & (Role.Manager | Role.PrimaryManager)) != 0;

    this.route.params.subscribe(p => {
      this.actionItemId = p['actionItemId'];
    })
    this.isMaster = this.tenantName == Constants.RiskSpongeMaster;
    this.userService.getAllShort(this.tenantName).subscribe(u => this.users = u);
    this.tenantService.getCurrent().subscribe(p => {
      this.isEditable = !p || p.isEditICSAndAPEnabled;
    });
    this.loadActionItems();
    this.loadSettings();
  }

  loadActionItems() {
    this.actionItemService.getAllActionItemTemplateSets().subscribe(t => {
      this.actionItemSets = t;
      this.actionItemSets.forEach(s => {
        s.selectedItems = [];
        s.selectedItems.push(s.actionPlanTemplates.find(t => s.id == this.actionItemId) || (this.actionItemId == 0 ? s.actionPlanTemplates[s.actionPlanTemplates.length - 1] : s.actionPlanTemplates[0]));
        s.actionItemForms = [];
        s.actionPlanTemplates.forEach(p => {
          p.view = true;
          p.originalCategory = p.category;
          s.actionItemForms.push(this.initForm(p));
        });
        this.updateRowGroupMetaData(s);
      })
    });
  }

  save(set, i) {
    if (set.actionItemForms[i].valid) {
      const result = set.actionItemForms[i].value;
      this.actionItemService.saveActionItem(result).subscribe(() => {
        set.actionPlanTemplates[i] = result;
        set.selectedItems.push(result);
        this.alertService.success("Successfully saved");
        this.loadActionItems();
      });
    } else {
      Object.keys(set.actionItemForms[i].controls).forEach(field => {
        const control = set.actionItemForms[i].get(field);
        control.markAsTouched({onlySelf: true});
      });
    }
  }

  editSet(set) {
    let config: MatDialogConfig = {
      panelClass: 'custom-overlay-pane-class',
      width: '30%',
      height: 'auto',
      data: { actionPlanSet: set }
    };

    const dialogRef = this.dialog.open(EditActionItemSetComponent, config);

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this.loadActionItems();
      }
    });
  }

  deleteSet(set) {
    this.actionItemService.deleteActionItemSet(set.id).subscribe(() => {
      this.loadActionItems()
    });
  }

  add(set) {
    set.actionItemForms.push(this.initForm({
      category: '',
      name: '',
      weaknessDescription: '',
      originalCategory: '',
      howIdentified: '',
      riskLevel: 'Unexisting',
      actionPlanId: 0,
      view: true,
      responsibleParty: null,
      identificationDate: null,
      currentStatus: null,
      scheduledCompletionDate: null,
      actualCompletionDate: null,
      remediationPlansActionsMilestones: '',
      changesToRemediationPlansActionsMilestones: null,
      comments: null,
      projectId: null,
      poamId: null,
      type: true,
      actionPlanTemplateId: null,
      assignedTo: null,
      actionPlanTemplateSetId: set.id
    }));
    const newVal = {name: "", text: "", id: 0};
    set.actionPlanTemplates.push(newVal);
    this.updateRowGroupMetaData(set);
  }

  selectDocument(node) {
    let config: MatDialogConfig = {
      panelClass: 'custom-overlay-pane-class',
      width: '80%',
      height: '90%',
      data: {}
    };

    const dialogRef = this.dialog.open(DocumentSelectComponent, config);

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        const quill = window['quills'].find(q => q.container === node.closest(".p-editor-container").querySelector(".ql-container"));
        const url = this.config.api + "/api/attachments/file?name=" + encodeURIComponent(result._orgData.name) + "&path=" + (result._orgData.folderId || "");
        quill.format('link', url, 'user');
      }
    });
  }

  dropActionItem(item) {
    this.actionItemService.deleteActionItem(item.value.actionPlanTemplateId).subscribe(() => this.loadActionItems());
  }

  dropActionItems(set, category) {
    this.actionItemService.deleteActionItems(set.actionPlanTemplates.filter(i => i.category == category).map(i => i.actionPlanTemplateId)).subscribe(() => this.loadActionItems());
  }

  dropAllActionItems(set) {
    this.actionItemService.deleteActionItems(set.actionPlanTemplates.map(i => i.actionPlanTemplateId)).subscribe(() => this.loadActionItems());
  }

  getFullName(user) {
    if (!user) {
      return '';
    }
    if (user.firstName != null
      || user.lastName != null) {
      return user.firstName + ' ' + user.lastName;
    }

    return user.emailAddress;
  }

  getFullNameById(userId) {
    const user = this.users.find(u => u.userId == userId);
    if (!user) return null;
    if (user.firstName != null
      || user.lastName != null) {
      return user.firstName + ' ' + user.lastName;
    }

    return user.emailAddress || user.emailAddress;
  }

  loadSettings() {
    this.clientProfileService.getSettings(this.tenantName).subscribe(t => this.settings = t);
  }

  up(set, item) {
    const i = set.actionPlanTemplates.indexOf(item);
    set.actionPlanTemplates[i] = set.actionPlanTemplates[i - 1];
    set.actionPlanTemplates[i - 1] = item;
    this.actionItemService.setActionItemOrder(set.actionPlanTemplates.map(p => p.id)).subscribe(() => {
      this.loadActionItems();
    })
  }

  down(set, item) {
    const i = set.actionPlanTemplates.indexOf(item);
    set.actionPlanTemplates[i] = set.actionPlanTemplates[i + 1];
    set.actionPlanTemplates[i + 1] = item;
    this.actionItemService.setActionItemOrder(set.actionPlanTemplates.map(p => p.id)).subscribe(() => {
      this.loadActionItems();
    })
  }

  addToken(html) {
    return html ? html.replace(/api\/attachments\/file\?/gi, 'api/attachments/file?token=' + LoginHelper.getFileToken() + '&') : html;
  }

  updateRowGroupMetaData(set) {
    const data = set.actionItemForms;
    this.rowGroupMetadata = this.rowGroupMetadata || {};
    this.rowGroupMetadata[set.id] = {};
    if (data) {
      for (let i = 0; i < data.length; i++) {
        let rowData = data[i];
        rowData.value.category = rowData.value.category || ' ';
        let brand = rowData.value.category || ' ';
        if (i == 0) {
          this.rowGroupMetadata[set.id][brand] = {index: 0, size: 1};
        } else {
          let previousRowData = data[i - 1];
          let previousRowGroup = previousRowData.value.category || ' ';
          if (brand === previousRowGroup)
            this.rowGroupMetadata[set.id][brand].size++;
          else
            this.rowGroupMetadata[set.id][brand] = {index: i, size: 1};
        }
      }
    }
  }

  uploadItems(event, set) {
    this.alertService.clear();

    let attachments = event.target.files;
    if (attachments.length > 0) {
      let file: File = attachments[0];
      this.actionItemService.uploadItems(file, set.id).subscribe(
        (res) => {

          let config: MatDialogConfig = {
            panelClass: 'custom-overlay-pane-class',
            width: 'auto',
            height: '90%',
            data: {
              items: res,

              title: "Import report"
            }
          };
          this.dialog.open(ListMessageComponent, config);
          this.loadActionItems();

        },
        (error) => {
          const errorMessage = 'An error occurred while upload implementation control statement items.';
          this.alertService.error(errorMessage);
        });
    }
  }
}
